import React, { useState, useEffect, useContext } from 'react';
import { Container, Row, Col, Form, Button, Card } from 'react-bootstrap';
import NavBar2 from '../components/Navbar2/NavBar2.js';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { getAuth } from "firebase/auth";
import { CartContext } from "../context/CartContext"; // Chemin à adapter

const Facturation = () => {
  const { cartItems } = useContext(CartContext); // Utilisation du contexte pour le panier
  const navigate = useNavigate();
  const auth = getAuth();
  const userId = auth.currentUser?.uid; // ID de l'utilisateur connecté
  const useremail = auth.currentUser?.email; // ID de l'utilisateur connecté

  const totalPrice = (cartItems || []).reduce(
    (sum, item) => sum + (item.price || 0) * (item.quantity || 1),
    0
  );

  // Données du formulaire
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    address: '',
    city: '',
    phone: '',
    cardNumber: '',
    expiryDate: '',
    cvc: '',
  });

  // État des produits et du paiement
  const [products, setProducts] = useState([]);
  const [orderTotal, setOrderTotal] = useState(0);
  const [paymentState, setPaymentState] = useState({
    status: 'idle',
    message: '',
  });

  // Gestion des changements dans les champs du formulaire
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));
  };

  // Récupération des produits dans le panier
  useEffect(() => {
    axios
      .get('http://localhost:5000/api/cart/cartItems')
      .then((response) => {
        const cartData = response.data[0]?.items || [];
        const updatedProducts = cartData.map((product) => ({
          ...product,
          totalPrice: (product.price || 0) * (product.quantity || 1),
        }));
        setProducts(updatedProducts);
        setOrderTotal(
          updatedProducts.reduce((sum, product) => sum + product.totalPrice, 0)
        );
      })
      .catch((error) => {
        console.error('Erreur lors de la récupération des produits :', error);
      });
  }, []);

  // Gestion du paiement
  const handlePayment = async () => {
    if (!userId) {
        alert("Vous devez être connecté pour passer une commande.");
        navigate("/login");
        return;
    }

    setPaymentState({ status: 'loading', message: 'Traitement en cours...' });

    try {
        const paymentData = {
            amount: orderTotal,
            cardDetails: {
                number: formData.cardNumber,
                expiry: formData.expiryDate,
                cvc: formData.cvc,
            },
            userDetails: {
                fullName: formData.fullName,
                email: formData.email,
                address: formData.address,
                city: formData.city,
                phone: formData.phone,
            },
        };

        // Envoi des données de paiement
        const paymentResponse = await axios.post(
            'http://localhost:5000/api/payment/flouci',
            paymentData
        );

        if (paymentResponse.data.success) {
            // Enregistrement de la commande
            const orderData = {
                userId,
                useremail,
                items: cartItems,
                totalPrice,
                paymentMethod: "Carte",
                paymentStatus: "success",
            };
           
            await axios.post('http://localhost:5000/api/orders/save', orderData);


            // Envoi d'un email de confirmation
            await axios.post('http://localhost:5000/api/emails/confirmation', {
                email: formData.email,
                fullName: formData.fullName,
                orderDetails: products,
            });
            const paymentData = {
              userId,
              useremail,
              totalPrice,
              paymentMethod: "Carte",
              paymentStatus: "success",
          };
          await axios.post('http://localhost:5000/api/orders/savepayment', paymentData);

            setPaymentState({
                status: 'success',
                message: 'Paiement et commande réussis !',
            });

            navigate('/success');
        } else {
            setPaymentState({
                status: 'error',
                message: paymentResponse.data.message || 'Paiement échoué.',
            });
        }
    } catch (error) {
        console.error('Erreur lors du paiement :', error);
        setPaymentState({
            status: 'error',
            message: 'Une erreur est survenue lors du paiement.',
        });
    }
};

  return (
    <Container fluid style={{ padding: '20px' }}>
      <div style={{ position: 'fixed', zIndex: '1', width: '94.5%', marginTop: '-15px' }}>
        <NavBar2 />
      </div>
      <Card style={{ marginTop: '70px', width: '100%' }} className="shadow-lg rounded">
        <Card.Body>
          <h2 className="text-center">Détails de la commande</h2>
          <Row>
            <Col md={6}>
              <Card className="mt-4 p-3">
                <h3>DETAILS DE FACTURATION</h3>
                <Form>
                  {/* Nom et email */}
                  <Row>
                    <Col md={6}>
                      <Form.Group controlId="formName">
                        <Form.Label>Nom Complet *</Form.Label>
                        <Form.Control
                          type="text"
                          name="fullName"
                          value={formData.fullName}
                          onChange={handleInputChange}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group controlId="formEmail">
                        <Form.Label>Email *</Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  {/* Adresse */}
                  <Form.Group controlId="formAddress">
                    <Form.Label>Adresse *</Form.Label>
                    <Form.Control
                      type="text"
                      name="address"
                      value={formData.address}
                      onChange={handleInputChange}
                      required
                    />
                  </Form.Group>
                  {/* Ville et téléphone */}
                  <Row>
                    <Col md={6}>
                      <Form.Group controlId="formCity">
                        <Form.Label>Ville *</Form.Label>
                        <Form.Control
                          type="text"
                          name="city"
                          value={formData.city}
                          onChange={handleInputChange}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group controlId="formPhone">
                        <Form.Label>Téléphone *</Form.Label>
                        <Form.Control
                          type="tel"
                          name="phone"
                          value={formData.phone}
                          onChange={handleInputChange}
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </Form>
              </Card>
            </Col>
            {/* Commande */}
            <Col md={6}>
              <Card className="mt-4 p-3">
                <h3>VOTRE COMMANDE</h3>
                <ul>
                  {products.map((product) => (
                    <li key={product.id}>
                      <h5>{product.name}</h5>
                      <p>Prix unitaire : {product.price} TND</p>
                      <p>Quantité : {product.quantity}</p>
                      <p>Total : {product.totalPrice} TND</p>
                    </li>
                  ))}
                </ul>
                <h5>Total : {orderTotal} TND</h5>
                {/* Paiement */}
                <h4>Paiement par Carte</h4>
                <Form.Group controlId="formCardNumber">
                  <Form.Label>Numéro de Carte</Form.Label>
                  <Form.Control
                    type="text"
                    name="cardNumber"
                    value={formData.cardNumber}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
                <Row>
                  <Col md={6}>
                    <Form.Group controlId="formExpiryDate">
                      <Form.Label>Date d'Expiration</Form.Label>
                      <Form.Control
                        type="text"
                        name="expiryDate"
                        value={formData.expiryDate}
                        onChange={handleInputChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group controlId="formCvc">
                      <Form.Label>CVV</Form.Label>
                      <Form.Control
                        type="text"
                        name="cvc"
                        value={formData.cvc}
                        onChange={handleInputChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Button
                  onClick={handlePayment}
                  className="mt-3"
                  disabled={paymentState.status === 'loading'}
                >
                  {paymentState.status === 'loading'
                    ? 'Traitement...'
                    : 'Passer la Commande'}
                </Button>
                {paymentState.status === 'error' && (
                  <p className="text-danger mt-2">{paymentState.message}</p>
                )}
              </Card>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default Facturation;
